import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'

const Home = () => {
  return (
    <div style={{height:'100vh'}}>
      <Navbar/>
      <Outlet/>
    </div>
  )
}

export default Home
